"use client"

import CTA from "@/components/Category/CTA";
import ToFAQ from "@/components/Category/ToFAQ";
import { site } from "@/data/default";
import { ReactNode } from "react";

export const serverContents: ReactNode = (
  <>
    <h2 className="text-2xl font-extrabold mb-6 leading-tight">Sewa Server Terdekat: Cara Paling Rasional Untuk Menang di Era Digital</h2>
    <div className="mb-8 text-base">
      <p className="mb-4">
        Membangun infrastruktur server dari nol bukan lagi solusi bijak untuk semua. Apalagi kalau ada pilihan lebih efisien: <strong>sewa server terdekat</strong> yang langsung siap pakai, tanpa drama teknis, tanpa modal besar di awal.
      </p>
      <p className="mb-4">
        Dari brand ternama seperti <strong>Dell, HP, IBM, hingga Supermicro</strong>, semua bisa kamu pilih sesuai kebutuhan: CPU tinggi, RAM lega, storage SSD cepat, dan OS custom. Semuanya siap dikirim ke lokasi kamu dari Jakarta,
        Bandung, Surabaya, sampai pelosok industri terpencil.
      </p>
    </div>
    <div className="grid gap-6">
      <section className="p-6 rounded-xl bg-white shadow border border-gray-200">
        <h2 className="font-semibold text-lg mb-2">Stok Server Ready di Lokasi Terdekat</h2>
        <p className="text-sm">
          Tidak perlu menunggu dari luar kota. Sistem distribusi kami memastikan kamu bisa <strong>sewa server terdekat</strong> dalam hitungan jam, bukan hari. Cocok untuk proyek dadakan, tender, hingga event berskala nasional.
        </p>
      </section>
      <section className="p-6 rounded-xl bg-white shadow border border-gray-200">
        <h2 className="font-semibold text-lg mb-2">Spesifikasi Server Bisa Diatur Sesuai Kebutuhan</h2>
        <p className="text-sm">
          Butuh <strong>server Intel Xeon 32 core</strong> dengan RAM 256GB? Atau cukup i7 dengan RAID 1 untuk backup data ringan? Semua bisa kamu sesuaikan. Tim kami bantu kurasi konfigurasi terbaik berdasarkan tujuan sewa kamu.
        </p>
      </section>
      <section className="p-6 rounded-xl bg-white shadow border border-gray-200">
        <h2 className="font-semibold text-lg mb-2">Harga Sewa Server Terdekat Bisa Disesuaikan</h2>
        <p className="text-sm">Sewa harian? Mingguan? Bulanan? Atau skema kontrak jangka panjang untuk B2B? Semua bisa dikustomisasi. Dan tenang, <strong>harga sewa server</strong> dari kami fleksibel, transparan, dan bisa nego.</p>
      </section>
      <section className="p-6 rounded-xl bg-white shadow border border-gray-200">
        <h2 className="font-semibold text-lg mb-2">Pengiriman Cepat & Gratis di Area Strategis</h2>
        <p className="text-sm">
          Di Jabodetabek, kami gratiskan ongkir untuk kampus, kantor, dan gedung pameran. Lokasi lainnya? Kami tetap bantu estimasi logistik terbaik demi memastikan kamu tetap dapat <strong>server terdekat tanpa delay</strong>.
        </p>
      </section>
      <section className="p-6 rounded-xl bg-white shadow border border-gray-200">
        <h2 className="font-semibold text-lg mb-2">Instalasi Server On-site Sampai Siap Pakai</h2>
        <p className="text-sm">
          Kami gak cuma kirim unitnya. Teknisi kami akan setup server langsung di tempat kamu. Mulai dari rack-mounting, konfigurasi OS, hingga testing konektivitas jaringan. Semua langsung <strong>plug & play</strong>.
        </p>
      </section>
      <section className="p-6 rounded-xl bg-white shadow border border-gray-200">
        <h2 className="font-semibold text-lg mb-2">Monitoring & Maintenance Aktif</h2>
        <p className="text-sm">
          Server sewaan bukan berarti dilepas begitu saja. Selama masa sewa, performa server kamu akan kami pantau. Kalau ada kendala, tim support siap turun langsung atau bantu remote. Karena <strong>sewa server</strong> itu harus bikin
          tenang, bukan tambah beban.
        </p>
      </section>
      <section className="p-6 rounded-xl bg-white shadow border border-gray-200">
        <h2 className="font-semibold text-lg mb-2">Pilihan Server Rack, Tower, Hingga Blade</h2>
        <p className="text-sm">
          Mau bentuk fisik server yang cocok sama ruang kerja kamu? Tersedia tipe <strong>rack server, tower, hingga blade server</strong> berstandar industri. Semua unit rutin kami rawat dan uji stabilitasnya sebelum sampai ke kamu.
        </p>
      </section>
    </div>
    <div className="mt-10 text-base">
      <p className="mb-4">Jangan biarkan bottleneck teknologi menghambat performa bisnis kamu. Dengan <strong>sewa server terdekat</strong>, kamu bisa scaling lebih cepat, tanpa biaya capex yang mengikat.</p>
      <p>Kirim lokasi kamu sekarang, dan biar tim kami rekomendasikan server yang paling pas dari segi <strong>harga, spek, brand, dan waktu pengiriman</strong>.</p>
    </div>

    <CTA
      title="Siap Host Data Bosku?"
      description="🚚 Butuh sewa server terdekat sekarang juga? Chat tim kami sekarang. <br />Kapan pun, di mana pun, selama unit ready, kami kirim hari itu juga."
      buttonText="Booking Server Sekarang"
      onClick={() => {
        window.open(
          `https://wa.me/${site.whatsapp}?text=Halo%2C%20saya%20ingin%20booking%20server.%20Lokasi%20dan%20tanggal%20sudah%20siap.`,
          "_blank"
        );
      }}
    />

    <ToFAQ
      category="Server"
    />

  </>
);
